import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import { sync } from 'vuex-router-sync'
import { loadView, loadComponent } from '@/mixins/asyncLoaders'
import objectHash from '@/mixins/objectHash'
import { Responsive } from '@/directives/responsive'
import { VUEX_APP_INIT } from '@/store/constants/app'
import '@/registerServiceWorker'
import 'quill/dist/quill.snow.css'
import 'quill-mention/dist/quill.mention.css'

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)

/* eslint-disable-next-line no-unused-vars */
const unsync = sync(store, router)

let appInstance = null
store.dispatch(VUEX_APP_INIT).then(() => {
	const app = createApp(App)

	app.use(router)
	app.use(store)
	app.use(vuetify)

	app.mixin(objectHash)
	app.directive('responsive', Responsive)

	app.config.globalProperties.loadView = loadView
	app.config.globalProperties.loadComponent = loadComponent

	router.afterEach(() => {
		if (window.Appcues) window.Appcues.page()
	})

	appInstance = app.mount('#app')
})

export default appInstance
